import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from '../../environments/environment';

// Reverb speaks the Pusher protocol, so laravel-echo's 'reverb' broadcaster
// still needs pusher-js as its transport - Echo picks it up off `window.Pusher`.
(window as any).Pusher = Pusher;

@Injectable({
    providedIn: 'root'
})
export class EchoService {

    readonly echo = new Echo<'reverb'>({
        broadcaster: 'reverb',
        key: environment.wsKey,
        wsHost: environment.wsHost,
        wsPort: environment.wsPort,
        wssPort: environment.wsPort,
        forceTLS: environment.wsScheme === 'https',
        enabledTransports: ['ws', 'wss'],
    });

    /** Public channel keyed by a tablet's own secret token - no Sanctum auth involved, see erp-backend's DocumentSignRequested event. */
    tabletChannel(token: string) {
        return this.echo.channel('tablet.' + token);
    }

    /** Public channel scoped by company id - carries the offline document-device heartbeat only (no sensitive data), see erp-backend's DocumentDeviceHeartbeat event. */
    documentDeviceChannel(companyId: number) {
        return this.echo.channel('document-device.' + companyId);
    }
}
